import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { convertRangeFilter, withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_MATERIAL_TRANSPARENT',
  GET: 'GET_MATERIAL_TRANSPARENT',
  CREATE: 'CREATE_MATERIAL_TRANSPARENT',
  EDIT: 'EDIT_MATERIAL_TRANSPARENT',
  DELETE: 'DELETE_MATERIAL_TRANSPARENT',
  DUPLICATE: 'DUPLICATE_MATERIAL_TRANSPARENT',
  CLEAR_ERROR: 'CLEAR_ERROR_MATERIAL_TRANSPARENT',
};

const fetchMaterialTransparent = (pageSize, page, sorted, search, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_MATERIAL_TRANSPARENT,
    params: {
      ...convertRangeFilter(filtered),
      search: search,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id).join(',')
        : null,
      is_public: isPublic === null ? null : (isPublic ? 'True' : 'False'),
    },
  });
};

export const searchTransparentMaterial = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filter = null;
  const isPublic = null;
  return fetchMaterialTransparent(pageSize, page, sorted, text, filter, isPublic);
};

export const listMaterialTransparent = (pageSize, page, sorted, search, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: fetchMaterialTransparent(pageSize, page, sorted, search, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createMaterialTransparent = (name, thickness, shgc, u, solarEnergyTransmittance, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('thickness', thickness);
  formData.set('SHGC', shgc);
  formData.set('transmittance', solarEnergyTransmittance);
  formData.set('U', u);
  formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null) formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `tq_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_MATERIAL_TRANSPARENT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editMaterialTransparent = (id, name, thickness, shgc, u, solarEnergyTransmittance, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (thickness) formData.set('thickness', thickness);
  if (shgc) formData.set('SHGC', shgc);
  if (solarEnergyTransmittance) formData.set('transmittance', solarEnergyTransmittance);
  if (u) formData.set('U', u);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `tq_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_MATERIAL_TRANSPARENT}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteMaterialTransparent = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_MATERIAL_TRANSPARENT}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateMaterialTransparent = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_MATERIAL_TRANSPARENT}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorMaterialTransparent = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/material_transparent/material_actions.js